import { ContactItemDto, ContactSearchRequestDto } from '@/api/generated';
import {
  contactStatusOptionsTranslation,
  ContactStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type ContactsTranslation = {
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: Record<keyof Omit<ContactItemDto, 'contactId'>, string>;
    head: Record<keyof ContactSearchRequestDto, string>;
    row: {
      statusOptions: ContactStatusOptionsTranslation;
    };
  };
};

export const contactsTranslation: ContactsTranslation = {
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: {
      contactOwnerId: 'Opiekun',
      customer: 'Klient',
      firstName: 'Imię',
      lastContactedAt: 'Ostatni kontakt',
      lastName: 'Nazwisko',
      name: 'Nazwa',
      ownerId: 'Utworzony przez',
      status: 'Status',
    },
    head: {
      customerFullTextSearchInput: 'Szukaj klienta',
      fullTextSearchInput: 'Szukaj',
      isAlreadyInCustomer: 'Przypisany do klienta',
      isAlreadyInSupplier: 'Przypisany do dostawcy',
      lastContactedFrom: 'Ostatni kontakt od',
      lastContactedTo: 'Ostatni kontakt przed',
      ownerIds: 'Opiekunowie',
      status: 'Status',
    },
    row: {
      statusOptions: contactStatusOptionsTranslation,
    },
  },
};
